export const SET_DATA = 'SET_DATA';
export const SET_PAGINATION = 'SET_PAGINATION';